import { Observable } from 'rxjs'
import { commonApi, getToken } from '../../../../api'

export const searchApi = <Result>() => ({
  search:
    (url: string, state) =>
    (obs$): Observable<{ _embedded: Result }> =>
      obs$.pipe(getToken(), commonApi.get(url, state)),
})
